import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useSearchModalStore } from "../../../store/useSearchModalStore";
import { useSearchInputStore } from "../../../store/useSearchInputStore";
import iconClose from "../assets/icon_close.svg";
import SearchInputContainer from "../searchInputContainer/SearchInputContainer";
import SearchTab from "../searchTab/SearchTab";
import SearchTabContent from "../searchTabContent/SearchTabContent";

import "./SearchModal.scss";
import "../../../component/bootstrap/modal/Modal.css";
import EmptySearchView from "../emptySearchView/EmptySearchView";
import { logSearch } from "../../../util/analytics";
import {brandUrl, getRectangleAdId, searchUrl} from "../../../util/url";
import { useNavigate } from "react-router-dom";
import AdFitAd from "../../../component/ad/AdFitAd";

/**
 * Search modal
 * @param hostname
 * @param userAgent
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function SearchModal({ hostname, userAgent }) {
  const { isOpen, closeModal } = useSearchModalStore();
  const { searchQuery, initSearchQuery } = useSearchInputStore();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("BRAND");

  const handleOnBrandClick = useCallback((search) => {
    if (!search) return;

    initSearchQuery();
    logSearch(search);
    navigate(`${brandUrl(search)}?isSearch=true`);
    closeModal();
  }, []);

  const handleOnQueryClick = useCallback((search) => {
    if (!search) return;

    initSearchQuery();
    logSearch(search);
    navigate(searchUrl(search));
    closeModal();
  }, []);

  if (!isOpen) {
    document.body.style = `overflow: auto`;
    document.body.style.position = "";
    return null;
  } else {
    document.body.style = `overflow: hidden`;
    document.body.style.position = "fixed";
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <dialog className="Modal modal fade show" tabIndex="-1" aria-hidden="true">
      <div
        className="modal-dialog modal-fullscreen SearchModalDialog"
        role="document"
      >
        <div className="Modal-content modal-content">
          <div className="Modal-body modal-body SearchModalDialog-body">
            <div className="SearchModalDialog-content">
              <div className="header">
                <div className="search">
                  <SearchInputContainer />
                </div>
                <div onClick={closeModal} className="closeContainer">
                  <img alt={"close"} src={iconClose} />
                </div>
              </div>

              <div className="content-container">
                {searchQuery.length > 0 ? (
                  <>
                    <SearchTab
                      activeTab={activeTab}
                      onTabChange={handleTabChange}
                    />
                    <SearchTabContent
                      activeTab={activeTab}
                      hostname={hostname}
                      userAgent={userAgent}
                      handleOnBrandClick={handleOnBrandClick}
                      handleOnQueryClick={handleOnQueryClick}
                    />
                  </>
                ) : (
                  <EmptySearchView
                    handleOnBrandClick={handleOnBrandClick}
                    handleOnQueryClick={handleOnQueryClick}
                  />
                )}
              </div>
              <div className="SearchModalDialog-footer" />
              <div className="SearchModalDialog-ad">
                <AdFitAd width={320} height={50} unit={getRectangleAdId(hostname)} style={{width : 350 , height: 50}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </dialog>
  );
}

SearchModal.propTypes = {
  hostname: PropTypes.string.isRequired,
  userAgent: PropTypes.string.isRequired,
};
